import { UtxAppEmbed } from '@/design-system/components/utxAppEmbedCallback/utxAppEmbedCallback';
import { useRoute } from '@react-navigation/native';
import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { SelectExchangeNativeScreen } from './SelectExchangeNative.screen';
import { SelectExchangeWebScreen } from './SelectExchangeWeb.screen';

export interface SelectExchangeProps {}
export const SelectExchangeScreen: React.FC<SelectExchangeProps> = () => {
  const layout = useContext(LayoutContext);
  const route = useRoute();

  if (layout.isMobile) {
    return (
      <UtxAppEmbed route={route.name}>
        <SelectExchangeNativeScreen />
      </UtxAppEmbed>
    );
  }
  return <SelectExchangeWebScreen />;
};
